var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 1H7.25C3.79822 1 1 3.79822 1 7.25V19.75C1 23.2018 3.79822 26 7.25 26H19.75C23.2018 26 26 23.2018 26 19.75V7.25C26 3.79822 23.2018 1 19.75 1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 12.7124C18.6544 13.7527 18.4767 14.8152 17.9923 15.7487C17.5079 16.6822 16.7416 17.4392 15.8022 17.912C14.8628 18.3848 13.7982 18.5494 12.7599 18.3823C11.7215 18.2152 10.7623 17.725 10.0187 16.9813C9.27502 16.2377 8.78479 15.2785 8.61771 14.2402C8.45063 13.2018 8.6152 12.1373 9.08803 11.1979C9.56086 10.2585 10.3179 9.49206 11.2514 9.00769C12.1849 8.52332 13.2473 8.34562 14.2876 8.49989C15.3488 8.65724 16.3312 9.15172 17.0897 9.91027C17.8483 10.6688 18.3428 11.6512 18.5001 12.7124Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 6.625H20.3875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.23b978434c47616adef82325a93c6fae.svg";
export { ForwardRef as ReactComponent };